import { useRachelStore } from '../store/rachel.store';
import { selectIsRachelOpen } from '../store/rachel.store.selectors';
import { useIsRachelAvailable } from './useIsRachelAvailable';
import { useRachelPresentation } from './useRachelPresentation';

export const useIsRachelDocked = (): boolean => {
  const isAvailable = useIsRachelAvailable();
  const isOpen = useRachelStore(selectIsRachelOpen);
  const { mode } = useRachelPresentation();

  return isAvailable && isOpen && mode === 'docked';
};
